import { Configs } from "@/configs";
import { getCookie, setCookie } from "@/utils";

const COOKIE_NAME = "miq_logger_enabled";

const isLogEnabled = (() => {
  if (Configs.env === "dev") return true;
  return getCookie(COOKIE_NAME) === "true";
})();

const enableLogger = () => {
  setCookie(COOKIE_NAME, "true");
};

const disableLogger = () => {
  setCookie(COOKIE_NAME, "false");
};

const logger = {
  info: (...args) => {
    if (!isLogEnabled) return;
    console.info(`MiQ::Logs:${args[0]}`, ...args.slice(1));
  },
  warn: (...args) => {
    if (!isLogEnabled) return;
    console.warn(`MiQ::Logs:${args[0]}`, ...args.slice(1));
  },
  error: (...args) => {
    if (!isLogEnabled) return;
    console.error(`MiQ::Logs:${args[0]}`, ...args.slice(1));
  },
  debug: (...args) => {
    if (!isLogEnabled) return;
    console.debug(`MiQ::Logs:${args[0]}`, ...args.slice(1));
  },
};

const Logger = { disableLogger, enableLogger, ...logger };

export default Logger;

export { disableLogger, enableLogger, logger };
